import { useMemo } from 'react';
import useLocalStorage from './useLocalStorage';

type OverallStats = Record<string, {
    moves?: number,
    solved?: boolean,
  }>

  
export function calculateCurrentStreak(overallStats: OverallStats) {
  const today = new Date().toISOString().split('T')[0];
  let day = today;
  let streak = 0;
  while (overallStats[day]?.solved) {
    streak++;
    day = new Date(new Date(day).getTime() - 24 * 60 * 60 * 1000).toISOString().split('T')[0];
  }
  return streak;
}

export function calculateLongestStreak(overallStats: OverallStats) {
  let longest = 0;
  let current = 0;
  for (const day in overallStats) {
    if (overallStats[day]?.solved) {
      current++;
    } else {
      longest = Math.max(longest, current);
      current = 0;
    }
  }
  return Math.max(longest, current);
}

export function calculateCompletionCount(overallStats: OverallStats) {
  return Object.values(overallStats).filter(day => day.solved).length;
}

export function calculateCompletionPercentage(overallStats: OverallStats, completionCount: number) {
  return Object.keys(overallStats).length === 0 ? 0 : completionCount / Object.keys(overallStats).length * 100;
}

export function calculateAverageMoves(overallStats: OverallStats, completionCount: number) {
  const totalMoves = Object.values(overallStats).reduce((total, day) => total + (day.moves || 0), 0);
  return completionCount === 0 ? 0 : totalMoves / completionCount;
}

export function useStats() {
  const [overallStats, setOverallStats] = useLocalStorage<OverallStats>('overallStats', {})

  const currentStreak = useMemo(() => calculateCurrentStreak(overallStats), [overallStats]);
  const longestStreak = useMemo(() => calculateLongestStreak(overallStats), [overallStats]);
  const completionCount = useMemo(() => calculateCompletionCount(overallStats), [overallStats]);
  const completionPercentage = useMemo(() => calculateCompletionPercentage(overallStats, completionCount), [overallStats, completionCount]);
  const averageMoves = useMemo(() => calculateAverageMoves(overallStats, completionCount), [overallStats, completionCount]);
 
  return {
    currentStreak,
    longestStreak,
    completionCount,
    completionPercentage,
    averageMoves,
    setOverallStats
  };
}

export default useStats;